/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import queryString from "query-string";
import { Button as MuiButton } from "@mui/material";
import { Helmet } from "react-helmet";
import ReloadIcon from "../../../assets/svg/ReloadIcon";
import Loader from "../../../components/common/Loader/Loader";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import useUserConfig from "../../../hooks/useUserConfig";
import {
  Constants,
  AlertStatus,
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  DEACTIVATED,
} from "../../../contants";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
} from "../../../redux/selectors/user";
import styles from "../../Emailer/EmailerRecipients/EmailerReceipients.styles";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import { getFormattedQuery } from "../../Emailer/EmailerRecipients/utils";
import VerificationTable from "./VerificationTable";
import Member from "../../../services/api/member";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import { ROUTES } from "../../../utils/constants";
import useParamsQuery from "../../../hooks/useParamsQuery";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
import PersonalDetailsSearch from "../MemberSearch/PersonalDetailsSearch";
import OrganizationSearch from "../MemberSearch/OrganizationSearch";
import {
  getFilters,
  handleDependencyFilter,
  performOperation,
} from "../MemberSearch/utils";
import Modal from "../../../components/common/Modal/Modal";
import RejectedDeactivation from "../MemberSearch/MemberToggleStatus/RejectDeactivation";
import MemberToggleStatusForHelpDesk from "../MemberSearch/MemberToggleStatus/MemberToggleStatusForHelpDesk";
import Toast from "../../../components/common/Toast";

const LOADER_DELAY = 1000;
const PAGE = "page";

const intialPaginationState = {
  currentPage: 0,
  totalPages: 0,
  totalElements: 0,
  pageSize: Constants.DEFAULT_PAGE_SIZE,
};

const DEACTIVATION_STATUS = "INITIATED";
const filterOrder = [
  "areaId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

function DeactivationVerification() {
  const TITLE = "Member Deactivation Verification - BSG";
  const [searchData, setSearchData] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState(intialPaginationState);
  const [selectedMember, setSelectedMember] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openRejectModal, setRejectOpenModal] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );
  const { isHelpDesk, isHelpDeskAdmin } = useSelector(selectAllSIUsers);
  const hasPermission = useUserConfig();
  const [totalElements, setTotalElements] = useState(0);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const toast = useContext(ToastAlertContext);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const metaData = useSelector((state) => state.meta);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const [showToast, setShowToast] = useState(null);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const onModalToggle = () => setOpenModal((prev) => !prev);
  const onRejectModalToggle = () => setRejectOpenModal((prev) => !prev);

  const getRoutePath = () => ROUTES.MEMBER_DEACTIVATION.path;

  const updatePaginationInfo = (pagination) => {
    setPaginationInfo({
      currentPage: pagination.number,
      totalPages: pagination.totalPages,
      totalElements: pagination.totalElements,
      pageSize: pagination.size,
    });
  };

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const resetFormState = () => {
    setAppliedFilters([]);
    setPaginationInfo(intialPaginationState);
    clearFormRef();
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePath()}?${query}`);
    } else {
      navigate(`${getRoutePath()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = { ...queryObject, page: 0 };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    setPaginationInfo(intialPaginationState);
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
    clearFormRef();
  };

  const fetchSearchData = async (queryParams) => {
    try {
      const formattedQuery = getFormattedQuery(queryParams);
      setIsLoading(true);
      const { data } = await Member.getDeactivationList({
        ...formattedQuery,
        status: DEACTIVATION_STATUS,
      });

      setTimeout(() => {
        setSearchData(data.content);
        updatePaginationInfo(data);
        setTotalElements(data.totalElements);
        setIsLoading(false);
        // ✅ Always show modal when data loads
        setOpenResultModal(true);
      }, LOADER_DELAY);
    } catch (error) {
      setIsLoading(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      console.error(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setPaginationInfo(intialPaginationState);

    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);

    const hasFilter = Object.values(formData).some(
      (val) => val && String(val).trim() !== ""
    );
    if (!hasFilter) {
      setShowToast({
        severity: "warning",
        message: "Please select your search filter",
      });
      return;
    }

    const query = queryString.stringify(formData);

    document.dispatchEvent(new Event(EVENT_NAME));
    updateSearchParam(query);
  };

  const onMemberStatusToggle = (member) => {
    setSelectedMember(member);
    onModalToggle();
  };

  const onRejectDeactivation = (member) => {
    setSelectedMember(member);
    onRejectModalToggle();
  };

  // ✅ Initial load on mount
  useEffect(() => {
    fetchSearchData({});
  }, []);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (queryObject && !isEmptyObj(queryObject)) {
      const [query, params] = getQueryParams(queryObject);
      fetchSearchData(query, params);
      initializeFormState(query);
    }
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      delete query.page;
      delete query.size;
      setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
    } else {
      setAppliedFilters([]);
    }
  }, [metaData, urlSearchParams.toString()]);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      page: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      page: 0,
      size: queryObject.size
        ? performOperation(
            queryObject.size,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };

  const onRefresh = () => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const [query, params] = getQueryParams(queryObject);
      fetchSearchData(query, params);
    } else {
      fetchSearchData({});
    }
  };

  const getTitle = () =>
    selectedMember?.member?.status === DEACTIVATED
      ? "Verify Member deactivation"
      : "Reason for deactivating the Member?";

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
  };

  const handleResetAndClose = () => {
    resetFormState();
    updateSearchParam();
    fetchSearchData({});
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div style={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <MuiButton
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </MuiButton>
        </div>

        {/* Search Form */}
        <div style={styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Organization Structure
              </div>
              <OrganizationSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Personal Details
              </div>
              <PersonalDetailsSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-end",
                paddingTop: isMobile ? "10px" : "10px",
                marginRight: isMobile ? "15px" : "10px",
                paddingBottom: isMobile ? "100px" : "0px",
              }}
            >
              <MuiButton
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  width: isMobile ? "90%" : "auto",
                }}
              >
                Search
              </MuiButton>
            </div>
          </form>
        </div>
        {/* Mobile separator border - visual boundary */}
        {isMobile && (
          <div
            style={{
              borderTop: "2px solid #ffffffff",
              paddingTop: "15px",
              paddingBottom: "30px",
              marginTop: "10px",
            }}
          />
        )}

        {isLoading && <Loader />}

        {/* Search Results Modal */}
        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "0px 10px 2px 10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : (
            <>
              {/* Header Row */}
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginTop: "5px",
                  marginBottom: "0px",
                  paddingBottom: "5px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {/* Left: Total + Filters */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: "0 0 auto" }}>
                    Total Members: {totalElements}
                  </div>
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={styles.filterWrapper}>
                        <div style={styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Right: Reload + Back + Clear */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <div style={styles.reload} onClick={onRefresh}>
                    <ReloadIcon />
                  </div>
                  <MuiButton
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </MuiButton>
                  <MuiButton
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </MuiButton>
                </div>
              </div>

              {/* Table */}
              <div style={{ flex: 1, overflowX: "auto", marginTop: "15px" }}>
                <VerificationTable
                  searchData={searchData}
                  currentPage={paginationInfo.currentPage}
                  pageSize={paginationInfo.pageSize}
                  hasPermission={hasPermission}
                  showStatusColumn={isHelpDesk || isHelpDeskAdmin}
                  totalElements={totalElements}
                  onMemberStatusToggle={onMemberStatusToggle}
                  onRejectDeactivation={onRejectDeactivation}
                  onRefresh={onRefresh}
                />
              </div>

              {/* Pagination */}
              {searchData.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <Pagination
                    totalPages={paginationInfo.totalPages}
                    totalResults={paginationInfo.totalElements}
                    currentPage={paginationInfo.currentPage}
                    pageSize={paginationInfo.pageSize}
                    onChange={onPaginationClick}
                    onPageSizeClick={onPageSizeClick}
                  />
                </div>
              )}
            </>
          )}
        </Modal>

        {/* Action Modals */}
        <Modal
          open={openModal}
          onClose={onModalToggle}
          title={getTitle()}
          customStyle={{
            maxHeight: "98%",
            overflowY: "auto",
            maxWidth: "100%",
          }}
        >
          <MemberToggleStatusForHelpDesk
            selectedMember={selectedMember}
            onClose={onModalToggle}
            callBack={onRefresh}
            forHelpdesk
          />
        </Modal>

        <Modal open={openRejectModal} onClose={onRejectModalToggle}>
          <RejectedDeactivation
            selectedMember={selectedMember}
            onClose={onRejectModalToggle}
            callBack={onRefresh}
          />
        </Modal>

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => setShowToast(null)}
        />
      </div>
    </>
  );
}

export default DeactivationVerification;
